export const filterDataUpdates = <T extends Record<string, unknown>>(
  oldData: T,
  newData: T
): Partial<T> => {
  const updates: Partial<T> = {};

  Object.entries(newData).forEach(([key, value]) => {
    if (JSON.stringify(oldData[key as keyof T]) !== JSON.stringify(value)) {
      updates[key as keyof T] = value as T[keyof T];
    }
  });

  return updates;
};
